import { ArticleParagraph2, IconFunctionalInformationCircle16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';

interface IValuationBannerComponentProps {
  onClick: () => void;
  isDesktop: boolean;
}

export const ValuationBannerComponent: React.FC<IValuationBannerComponentProps> = ({ isDesktop, onClick }) => {
  return (
    <div className={styles['wrapper']}>
      {isDesktop && <IconFunctionalInformationCircle16 color="primary_100" />}

      <ArticleParagraph2 color="black_100">Оценка переехала в новый раздел — Мой дом.</ArticleParagraph2>

      <ArticleParagraph2 onClick={onClick} color="primary_100">
        Подробнее
      </ArticleParagraph2>
    </div>
  );
};
